export default {
	italian: "Italian",
	english: "English",
	japanese: "Japanese",
	french: "French",
	german: "German",
	spanish: "Spanish",
	sun_description:
		"The sun is a medium-sized star located at the center of our solar system. It is a source of light and heat that sustains life on Earth. Composed mainly of hydrogen and helium, it generates energy through nuclear fusion. Its mass and gravity keep the planets and other celestial bodies in orbit around it.",

	// Common UI Elements
	save: "Save",
	delete: "Delete",
	close: "Close",
	clear: "Clear",
	cancel: "Cancel",
	next: "Next",
	back: "Back",
	done: "Done",
	search: "Search...",

	// Authentication
	email: "E-mail",
	password: "Password",
	remember_me: "Remember me",
	forgot_password: "Forgot Password?",
	sign_in: "Sign in",
	email_required: "Email is required",
	password_required: "Password is required",
	check_username_password: "Please check your username and password!",

	// Profile
	member_type: "Member type",
	location: "Location",
	copy_jwt: "Copy JWT",
	edit_profile_image: "Edit profile image",
	public_profile: "Public profile",
	club_profile: "Club profile",
	open_position: "Open Position",
	career_profile: "Career profile",
	contractual_data: "Contractual data",
	account_information: "Account information",
	security: "Security",

	// Profile Form Fields
	phone: "Phone",
	street: "Street",
	zip: "ZIP",
	town: "Town",
	add_phone_number: "Add your phone number",
	add_street_address: "Add your street address",
	add_zip_code: "Add your ZIP code",
	add_town: "Add your town",
	add_first_name: "Add your first name",
	add_last_name: "Add your last name",
	additional_citizenship: "Additional Citizenship",
	select_additional_citizenship: "Select additional citizenship",
	add_instagram_handle: "Add your instagram handle",
	add_wechat_handle: "Add your wechat handle",
	add_facebook_url: "Add your facebook page URL",
	add_bluesky_handle: "Add your bluesky handle",
	add_twitter_handle: "Add your X / twitter handle",
	add_website_url: "Add your website URL here",

	// Player Stats
	current_world_ranking: "Your current world ranking",
	best_world_ranking: "Best world ranking",
	current_world_ranking_placeholder: "What is your current world ranking?",
	best_world_ranking_placeholder: "What was your beste world ranking?",
	other_successes: "Other successes",
	continent: "Continent",
	current_continent_ranking: "Your current ranking on this continent",
	country: "Country",
	club_name: "Club name",
	minimum_salary_per_game: "Minimum salary per game (USD)",

	// Trainer Stats
	salary_usd: "Salary in USD",
	license_level: "License Level",
	add_current_salary: "Add your current salary",
	add_license_level: "Add your license level",

	// Club Open Positions
	open_for_players: "Open for players",
	open_until_date: "Open until date",
	additional_information: "Additional information",
	save_open_positions: "Save Open Positions",

	// Search and Filters
	search_for_name: "Search for name",
	search_for_country: "Search for country",
	filter_category: "Filter category",
	advanced_search: "Advanced search",
	min_world_ranking: "Min. world ranking",
	min_us_points: "Min. US points",
	min_continental_ranking: "Min. continental ranking",
	select_continent: "Select continent",
	min_salary_per_game: "Salary per game from (USD)",
	max_salary: "Max. salary (USD)",
	select_license_level: "License level",
	select_language: "Language",

	// Messages and Notifications
	failed_to_update_image: "Failed to update image",
	error_submitting_form: "Error submitting form",
	access_denied_club_users: "Access denied. Only club users can access open positions.",
	token_copied: "✅ Token copied!",
	token_copy_failed: "❌ Token could not be copied",
	web_push_subscription_inactive: "You have a web push subscription but it is not active. Please logout and login again to activate it.",

	// Page Titles
	multi_language: "Multi Language",
	not_found: "404 Not Found",

	// Form Elements
	column_title: "Column title...",
	task_title: "Task title...",
	meaningful_title_hint: "What should this be about? Add a meaningful title here!",
	meaningful_title_placeholder: "What should this be about? Add a meaningful title here!",
	message: "Message...",

	// Chat Messages
	you_did_not_start_conversation: "You did not start a conversation yet.",
	head_over_community_pages: "Please head over to the community pages to start a new conversation with one of our members!",
	select_a_conversation: "Select a conversation",
	select_a_contact: "Select a Contact",
	start_new_chat_with: "Start a new chat with '{name}' by sending a new message",

	// Profile Personal
	public_information: "Public information",
	other_members_can_see_personal_info: "Other members of our community can see this personal information.",
	socials: "Socials",
	website: "Website",
	other_profiles_video_urls: "Other profiles and video URLs",
	which_country_live: "Which country do you live in?",
	citizenship: "Citizenship",
	instagram: "Instagram",
	wechat: "WeChat",
	facebook: "Facebook",
	threads: "Threads",
	bluesky: "BlueSky",
	x_twitter: "X / Twitter",
	external_profile_urls: "External profile URLs",
	external_video_urls: "External video URLs",
	bio: "Bio",

	// Validation
	valid: "Valid",
	invalid: "Invalid",

	// Tour Guide
	logo: "Logo",
	breadcrumb: "Breadcrumb",
	latest_pinned_pages: "Latest/Pinned pages",

	// Demo Content
	icons: "Icons",
	basic: "Basic",
	carousel: "Carousel",
	play: "Play",
	refresh_view_tool: "Refresh view tool",
	stoner: "Stoner",
	refresh_view: "Refresh view",

	// Auth Form
	welcome_to_ttpronet: "Welcome to TTProNet",
	be_part_of_ttpronet: "Be part of TTProNet",
	forgot_your_password: "Forgot your password?",
	created_by_robert_gardos: "Created by Robert Gardos",
	register_for_free: "Register for free!",
	password_reset_instruction: "Enter your e-mail address and we will provide you a link to reset your password.",
	dont_have_account: "Don't you have an account?",
	sign_up: "Sign up",
	back_to_sign_in: "Back to Sign in",
	do_you_have_account: "Do you have an account?",
	send_reset_link: "Send Reset Link",

	// Sign Up Form
	select_your_country: "Select your country",
	confirm_password: "Confirm Password",
	enter_password_again: "Please enter the password again",
	register_as: "I want to register as...",
	player: "Player",
	trainer: "Trainer",
	manager: "Manager",
	club: "Club",
	first_name: "First name",
	last_name: "Last name",
	birthdate: "Birthdate",
	agree_to: "I agree to the",
	terms_of_use: "terms of use",
	create_account: "Create an account",
	password_requirements: "At least 8 characters long<br>Min. 1 letter<br>Min. 1 number<br>Min. 1 special character",
	register_explore_upgrade: "Register for free and explore TTProNet! Upgrade to a full account anytime to unlock even more features!",
	please_select: "Please select!",

	// Sign Up Success
	account_created_successfully: "Account Created Successfully!",
	welcome_to_ttpronet_success: "Welcome to TTProNet! Your account has been created and you're ready to start exploring our platform. We have sent you a confirmation email with a link to activate your account.",
	go_to_login: "Go to Login",

	// Sign Up Warning
	account_created_warning: "Account Created with Warning",
	account_created_email_failed: "Your account has been successfully created, but we were unable to send the confirmation email. Please use the password reset function or contact us for assistance.",
	reset_password: "Reset Password",

	// Profile Components
	account_information_description: "These fields are only used by TTProNet. Community members can <b>not</b> see this information, except the country you live in - this information is public.",
	contractual_information: "Contractual Information",
	contractual_information_description_trainer: "These values are not displayed directly, but they can help players and clubs finding you.",
	contractual_information_description_player: "These values are not displayed directly, but they can help trainers, managers and clubs finding you.",
	contractual_information_description_manager: "These values are not displayed directly, but they can help players, trainers and clubs finding you.",
	club_information: "Club information",
	club_information_description: "Other members of our community can see this club information.",
	club_location_question: "In which country is the club located?",
	rankings_and_memberships: "Rankings And Memberships",
	rankings_memberships_description: "Other members of our community can see these informations:",
	your_current_us_points: "Your current US points",
	most_us_points: "Most US points",
	continental_rankings: "Continental rankings",
	regional_rankings: "Regional rankings",
	i_play_for_these_clubs: "I play for these clubs:",
	your_club_not_in_list: "Your club is not in our list?",
	club_not_in_list_description: "Please enter the country and the name of your club and we will add it for you!",
	leagues_i_play_in: "Leagues I play in:",
	league_not_listed: "You are playing in a league that is not listed?",
	league_not_listed_description: "Just enter the name(s) of the league(s) you play in here!",
	managing_fee_percent: "Managing fee in %",
	open_position_management: "Open Position Management",
	open_position_management_description: "Manage whether your club is currently accepting new trainers and players.",
	open_for_players_section: "Open for Players",
	open_for_trainers_section: "Open for Trainers",
	open_for_trainers: "Open for trainers",
	password_section: "Password",
	password_description: "Please use a strong password for your own account security.",
	repeat_password_confirmation: "Repeat password for confirmation",
	identity_verification: "Identity verification",
	identity_verification_description: "Uploading a personal document to verify your identity is not required by default. However, for enabling certain features, this may be necessary. Please only upload your document if our support team specifically requests it.",
	document_pdf: "Document (.pdf)",
	click_or_drag_file: "Click or drag a file to this area to upload",
	upload_starts_immediately: "The upload will start immediately after selecting or dragging the file.",
	failed_to_load_club_positions: "Failed to load club open positions",
	unauthorized: "Unauthorized",
	access_denied_club_update: "Access denied. Only club users can update open positions.",
	error_updating_open_positions: "Error updating open positions",

	// Validation Messages
	country_required: "Country is required",
	password_confirmation_required: "Password confirmation is required",
	passwords_not_match: "Password is not the same as re-entered password!",
	please_input_name: "Please input your name",
	please_input_age: "Please input your age",
	please_input_number: "Please input your number",
	please_add_phone_number: "Please add your phone number",
	please_add_street_address: "Please add your street address",
	please_add_zip_code: "Please add your ZIP code",
	please_add_town: "Please add your town",
	please_input_first_name: "Please input first name",
	please_input_last_name: "Please input last name",
	please_add_country: "Please add your country",
	please_set_password: "Please set your password",
	please_enter_password_twice: "Please enter your password twice for confirmation",
	please_input_event_title: "Please input event title",

	// Greetings
	good_morning: "Good morning",
	hi: "Hi",
	good_evening: "Good evening",

	// Notifications
	notifications: "Notifications",
	details: "Details",
	no_notifications: "There is no notification",
	mark_all_as_read: "Mark all as read",

	// News
	read_more: "Read more!",

	// Placeholders - Common
	email_example: "youraddress at email.com",
	select_profile_picture: "Select your profile picture",

	// Placeholders - Personal Info
	type_short_bio: "Type a short bio everyone can read about you!",
	add_club_name: "Add your club name",
	use_strong_password: "Use a strong password!",
	repeat_password: "Repeat the password",

	// Placeholders - Social Media
	type_threads: "Type threads",
	add_url_here: "Add a URL here",

	// Placeholders - Profile Stats
	current_world_ranking_question: "What is your current world ranking?",
	best_world_ranking_question: "What was your best world ranking?",
	us_points_current: "How many US points do you currently have?",
	us_points_maximum: "What was your maximum of US points?",
	describe_other_successes: "Describe other successes of yours - placements, rankings et al.",
	continent_placeholder: "Continent",
	current_continent_ranking_placeholder: "Your current ranking on this continent",
	region_placeholder: "Region (e.g. country, state)",
	current_region_ranking_placeholder: "Your current ranking in this region",
	league_name_placeholder: "League name",
	salary_per_game_placeholder: "Add your minimum salary per game in",
	managing_fee_placeholder: "Add your managing fee in %",

	// Placeholders - Kanban
	column_title_placeholder: "Column title...",
	task_title_placeholder: "Task title...",

	// Placeholders - Calendar
	event_title_placeholder: "Event Title",
	event_location_placeholder: "Event Location",
	event_description_placeholder: "Event Description",

	// Placeholders - Club Positions
	select_end_date: "Select end date",
	player_position_info: "Provide additional information about player positions (requirements, level, etc.)",
	trainer_position_info: "Provide additional information about trainer positions (requirements, experience level, etc.)",

	// Placeholders - Security/Documents
	document_types_placeholder: "Please use any of the mentioned document types",
	photo_id_placeholder: "Passport, ID card, Drivers License etc.",

	// Placeholders - Email
	email_subject_placeholder: "Message subject...",

	// Community Pages
	find_your_next_manager: "Find your next manager!",
	get_in_contact_with_trainers: "Get in contact with trainers!",
	find_players_around_world: "Find players around the world!",
	looking_for_clubs: "Looking for clubs?",
	clear_all: "Clear all",

	// Academy Pages
	lessons: "Lessons",
	download: "Download",
	open_in_browser: "Open in browser",
	upgrade_now_activate_downloads: "Upgrade now to activate downloads!",
	content_available_for_members: "This content is available for members with an active subscription.",

	// Forum Pages
	forum_list: "Forum list",
	start_a_conversation: "Start a conversation",
	latest_threads: "Latest Threads",
	me: "Me",
	add_a_new_post: "Add a new post",
	send: "Send",

	// API Response Messages - Authentication
	auth: {
		user_not_authenticated: "User not authenticated"
	},

	// API Response Messages - Forms
	form: {
		// Password-related messages
		password_confirmation_required: "Password and confirmation are required",
		password_too_common: "Password is too common!",
		passwords_do_not_match: "Passwords do not match",
		password_updated_successfully: "Password updated successfully",
		password_reset_sent_successfully: "Password reset request for \"{email}\" sent successfully",
		password_reset_failed: "Password reset request for \"{email}\" failed",
		password_validation_failed: "Please ensure that your password meets the requirements.",

		// User information messages
		information_updated_successfully: "Information updated successfully",
		invalid_request: "Invalid request",

		// Registration messages
		email_already_exists: "This e-mail address is already in use! Maybe try to reset your password?",
		invalid_role: "Invalid role!",
		date_of_birth_required: "Date of birth must not be empty!",
		minimum_age_required: "You must be at least 13 years old!",
		name_required: "First and last name must not be empty!",
		terms_acceptance_required: "You must accept the terms and conditions!",
		email_send_failed: "Failed to send confirmation email",
		registration_successful_with_warning: "Registration successful but with warnings",
		registration_failed: "Registration failed",
		registration_error_occurred: "An error occurred during registration",
		invalid_credentials: "Invalid credentials"
	}
}
